/*
 * This is an interim solution for automatically authenticating
 * CRM users into shared LionDesk Accounts
 *
 * TODO AK: remove this module and its uses when platform
 * and www are refactored to use LionDesk Accounts
 *
 */

import axios from 'axios';
import { CookieStorage } from 'cookie-storage';

const ACCOUNTS_COOKIE_KEY = 'LD_AUTH';
const V1_TOKEN_KEY = 'RL6Token';
const OLD_CRM_TOKEN = 'feathers-jwt';
const A_MONTH_FROM_TODAY = new Date(Date.now() + 2592000000);
// get domain without the subdomain
const domain =
  window.location.hostname
    .split('.')
    .slice(1)
    .join('.') || window.location.hostname;
const cookieStorage = new CookieStorage({
  expires: A_MONTH_FROM_TODAY,
  path: '/',
  domain,
});

export async function accountsLogin(user, pass) {
  const data = { credentials: { user, pass } };
  await axios
    .put(`${process.env.VUE_APP_ACCOUNTS_API}/authenticate`, data)
    .then(response => {
      cookieStorage.setItem(ACCOUNTS_COOKIE_KEY, response.data.accountsJWT);
    });
}

export function accountsLogout() {
  cookieStorage.removeItem(ACCOUNTS_COOKIE_KEY);
  cookieStorage.removeItem(V1_TOKEN_KEY);
  cookieStorage.removeItem(OLD_CRM_TOKEN);
}
